app.service('productTabDescription', function (productCardConfig, productDescriptionGrade, front, log) {
	let $self, $descriptionToggle;
	let isTabOpen = false;
	let config;

	function init() {
		setElements();
		setEvents();
		setDescriptionToggleText();

		if (!isTabOpen) {
			setCollapsedDescriptionHeight();
		}

		if (isTabOpen && config.showDescriptionGrade) {
			productDescriptionGrade.init();
		}
	}

	function setElements() {
		config = productCardConfig.getData();
		$self = $('#description');
		$descriptionToggle = $self.find('.js-description-toggle');
		isTabOpen = $self.hasClass('full-desc');
	}

	function setEvents() {
		$descriptionToggle.click(handleDescriptionToggleClick);

		$self
			.on('click', '.js-tech-details td:first-child a', function () {
				UA.interaction('KP - Opis', 'Słownik', 'Cecha - ' + $.trim($(this).text()) + ' - ' + config.groupName);
			})
			.on('click', '.js-tech-details td:last-child a', function () {
				UA.interaction('KP - Opis', 'Słownik', 'Wartość - ' + $.trim($(this).text()) + ' - ' + config.groupName);
			})
			.on('click', '#find-similar-products', function () {
				UA.pageInteraction('Opis', 'Znajdź podobne produkty');
			});
	}

	function setCollapsedDescriptionHeight() {
		const $descriptionContent = $self.find('.description-content');
		const collapsedPoint = $descriptionContent.data('collapse-point');

		if ($descriptionContent.find('.description-content-inner').height() > collapsedPoint) {
			$descriptionContent.css('max-height', $descriptionContent.data('collapsed-height'));
		} else {
			$self.addClass('small-desc');
		}
	}

	function handleDescriptionToggleClick() {
		$(this).blur();
		toggleTab();

		if (config.showDescriptionGrade) {
			productDescriptionGrade.init();
		}
	}

	function toggleTab() {
		isTabOpen = !isTabOpen;
		$self.toggleClass('full-desc', isTabOpen);
		setDescriptionToggleText();

		UA.pageInteraction("Opis", isTabOpen ? "Rozwiń opis" : "Zwiń opis");
		log.event({
			"id": "visitorInteraction",
			"f03": document.location.pathname,
			"f04": front.page(),
			"f05": "Opis i dane",
			"f06": isTabOpen ? "Rozwiń opis" : "Zwiń opis",
			"f07": ""
		});

		if (!isTabOpen) {
			$.scrollTo('[data-section-id=opis]');
		}
	}

	function setDescriptionToggleText() {
		const text = isTabOpen ? $descriptionToggle.data('read-less') : $descriptionToggle.data('read-more');
		$descriptionToggle.text(text);
	}

	return {
		init
	};
});